import { Component, OnInit } from '@angular/core';

import { SegmentService } from 'app/segment/segment.service';
import { CustomTitleService } from 'app/shared/service/custom-title/custom-title.service';

import { HomePageBaseComponent } from './home-page-base.component';

@Component({
  selector: 'cc-team-home-settings',
  templateUrl: 'team-home-settings.component.html',
  styleUrls: ['home-page-settings.component.scss', 'home-settings.component.scss'],
})
export class TeamHomeSettingsComponent extends HomePageBaseComponent implements OnInit {
  constructor(
    protected readonly segmentService: SegmentService,
    private readonly customTitleService: CustomTitleService,
  ) {
    super(segmentService);
  }

  ngOnInit() {
    this.customTitleService.setTitle(`Settings - Dashpivot`);
  }

  get activityLevel() {
    return 'team';
  }
}
